import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div>
      <h1>404</h1>
      <p>The page you're looking for was not found.</p>
      <Link to="/">Return to Home</Link>
    </div>
  );
};

export default NotFound;